export const SEND_MESSAGE_TOOL_NAME = 'SendMessage'
